import { createFileRoute } from '@tanstack/react-router'
import { RsvpPage } from '@/features/rsvp/rsvp-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/rsvp')({
  component: RsvpRoute,
})

function RsvpRoute() {
  const { workspaceSlug } = Route.useParams()

  return <RsvpPage workspaceSlug={workspaceSlug} />
}
